const initialState = {
  isConnected: true,
};

export function networkReducer(state = initialState, action) {
  switch (action.type) {
    case "NETWORK_CONNECTED":
      return { ...state, isConnected: true };
    case "NETWORK_DISCONNECTED":
      return { ...state, isConnected: false };
    default:
      return state;
  }
}
